import { Button, useMediaQuery, useTheme } from "@mui/material";
import { motion } from 'framer-motion';
const AddTwo = ({ handleClick }) => {
    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));

    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            background: '#000',
            paddingBottom: 80,
            paddingTop: 60,
            boxSizing: 'border-box',
            color: '#fff'
        },
        subContainer: {
            width: isMobile ? '90%' : isBig ? '85%' : '60%',
        },
        heading: {
            fontSize: isMobile ? '22px' : '45px',
            fontWeight: 'bold',
            textAlign: 'center',
            boxSizing: 'border-box'
        },
        buttonContainer: {
            marginTop: 20,
            textAlign: 'center',
        },
        button: {
            borderRadius: '30px',
            color: 'black',
            backgroundColor: 'rgb(255, 210, 48)',
            padding: '15px 60px',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '20px',
            '&:hover': {
                backgroundColor: 'rgb(255, 210, 48)',
                color: '#fff'
            },
            marginTop: 5,
            fontWeight: 'bold'
        },
    }

    return (
        <div style={styles.container}>
            <div style={styles.subContainer}>
                <motion.div
                    style={styles.heading}
                    initial={{ opacity: 0, y: 50, scale: 0.6 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: 0.5 }}
                >
                    Take the <span style={{ color: 'rgb(255, 210, 48)' }}> first step </span>
                    towards your
                    <span style={{ color: 'rgb(255, 210, 48)' }}> Business growth</span> by working with our
                    <span style={{ color: 'rgb(255, 210, 48)' }}> team.</span>
                </motion.div>

                <motion.div
                    style={{ fontSize: isMobile ? '16px' : '20px', marginTop: 50, textAlign: 'center' }}
                    initial={{ opacity: 0, y: 50, scale: 0.6 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: 0.5 }}
                >
                    Are you ready to take the first step? Click below now
                </motion.div>

                <div style={styles.buttonContainer}>
                    <Button sx={styles.button} onClick={handleClick}>Book a Call</Button>
                </div>
            </div>
        </div >
    )



}



export default AddTwo;